import styled from 'styled-components'
import rem from '../../../styles/tools/rem'

import { title16Galano, txt16OpenSansBold } from '../../../styles/settings/types'
import { paleGray, skyBlue, darkSlateBlue } from '../../../styles/settings/colors'

export const Separator = styled.hr`
  border-top: 2px solid ${paleGray};
  width: ${rem('960px')};
  margin: 0 auto;
`

export const ResetButton = styled.button`
  color: white;
  ${txt16OpenSansBold};
  border-width: 0;
  border-bottom: 2px solid white;
`

export const FormButton = styled.button`
  background-color: ${skyBlue};
  color: ${darkSlateBlue};
  ${title16Galano};
  padding: ${rem('13px')} ${rem('25px')};
  border-radius: 25px;
  margin-left: ${rem('20px')};
  border-width: 0;
  width: 173px;
  height: 52px;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  background-color: ${darkSlateBlue};
  height: ${rem('100px')};
  align-items: center;
  justify-content: space-around;
  display: flex;
  position: fixed;
  bottom: 0;
  z-index: 2;
`
export const ButtonsWrapper = styled.div`
  width: ${rem('960px')};
  background-color: ${darkSlateBlue};
  height: ${rem('100px')};
  align-items: center;
  justify-content: space-between;
  display: flex;
`



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilterForm/styles.js